interface Stat {
  num: string;
  unit?: string;
  label: string;
}

/**
 * Stats hardcoded — números verificados contra
 * `data/final/parcelas_unificado.geojson` el 2026-05-09:
 *   - 2,374 parcelas RAN totales del tenant Elawan (Huimilpan + Corregidora).
 *   - 14 ejidos / núcleos agrarios distintos (agrupado por nom_nucleo).
 *   - 2 municipios.
 *
 * Decisión 2026-05-09: se retiró "180 ha · Meta del proyecto" — la meta
 * arbitraria salió del tablero (TabAvance) por inconsistente con los
 * datos reales y aquí también se quita por coherencia narrativa.
 *
 * Si en el futuro estos números cambian materialmente, refactorizar a
 * cálculo dinámico desde el GeoJSON en build-time.
 */
const STATS: Stat[] = [
  { num: '2,374', label: 'Parcelas mapeadas' },
  { num: '14', label: 'Ejidos analizados' },
  { num: '2', label: 'Municipios' },
];

export function StatsRow() {
  return (
    <div className="stats-row" role="list">
      {STATS.map((s) => (
        <div className="stat" role="listitem" key={s.label}>
          <div className="num">
            {s.num}
            {s.unit && <small> {s.unit}</small>}
          </div>
          <div className="label">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
